export enum TipoStatoPropostaEnum {
  BOZZA = 1,
  DA_VALIDARE = 2,
  MODIFICATA_DAI_TECNICI = 3,
  VALIDATA = 4,
  APPROVATA = 5,
  RIFIUTATA = 6,
  DECRETATA = 7,
  ELIMINATA = 8,
  ARCHIVIATA = 9,
  RICOLLOCATA = 10,
  CAMBIO_NORMATIVA = 11
}

export const TipoStatoPropostaLabel: Record<TipoStatoPropostaEnum, string> = {
  [TipoStatoPropostaEnum.BOZZA]: "BOZZA",
  [TipoStatoPropostaEnum.DA_VALIDARE]: "DA VALIDARE",
  [TipoStatoPropostaEnum.MODIFICATA_DAI_TECNICI]: "MODIFICATA DAI TECNICI",
  [TipoStatoPropostaEnum.VALIDATA]: "VALIDATA",
  [TipoStatoPropostaEnum.APPROVATA]: "APPROVATA",
  [TipoStatoPropostaEnum.RIFIUTATA]: "RIFIUTATA",
  [TipoStatoPropostaEnum.DECRETATA]: "DECRETATA",
  [TipoStatoPropostaEnum.ELIMINATA]: "ELIMINATA",
  [TipoStatoPropostaEnum.ARCHIVIATA]: "ARCHIVIATA",
  [TipoStatoPropostaEnum.RICOLLOCATA]: "RICOLLOCATA",
  [TipoStatoPropostaEnum.CAMBIO_NORMATIVA]: "CAMBIO NORMATIVA"
};
